import React, { useState } from "react";
import logo256 from "./logo256.png";
import "./scss/style.scss";
import NumberInput from "./components/NumberInput";
import NumberButton from "./components/NumberButton";

function App() {
  const [min, setMin] = useState(1);
  const [max, setMax] = useState(100);
  const [nums, setNums] = useState([]);

  function genRandom() {
    if (nums.length >= max - min + 1) return alert(`You have went through all of the numbers between ${min} and ${max}. Click a number to remove it.`);
    let randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    if (nums.includes(randomNum)) genRandom();
    else setNums((prevState) => [...prevState, randomNum]);
  }
  return (
    <div className="app">
      <div className="container">
        <header className="my-2 text-center">
          <img src={logo256} alt="" className="logo" height={200} />
          <h1 className="mt-0 mb-2">Number Generator</h1>
          <h4 className="mb-4 text-secondary">Made by Shivam</h4>
          <hr />
        </header>
        <main>
          <div className="card generator">
            <div className="card-body">
              <h4 className="card-title mb-2">Generator</h4>
              <p className="card-text">Click below to generate a number.</p>
              <div className="gen-box">
                <button className="btn btn-purple mr-3 mb-2" onClick={genRandom}>
                  Generate
                </button>
                {!(nums.length > 1) || (
                  <button className="btn btn-info mr-3 mb-2" onClick={() => setNums((prevState) => [...prevState.sort((a, b) => a - b)])}>
                    Sort Numbers
                  </button>
                )}
                {!(nums.length > 0) || (
                  <button className="btn btn-danger mb-2" onClick={() => setNums([])}>
                    Clear All Numbers
                  </button>
                )}
              </div>
            </div>
            <div className="settings card-body text-center">
              <NumberInput val={min} setVal={setMin} valName={"Minimum"} max={max} min={-1e10} />
              <NumberInput val={max} setVal={setMax} valName={"Maximum"} min={min} />
              <small className="text-muted">Range inclusive</small>
            </div>
          </div>
          {!(nums.length > 0) || (
            <>
              <h5 className="my-3 text-center">Click a number to remove it</h5>
              <hr className="my-3" />
              <div className="numbers">
                {nums.map((num) => (
                  <NumberButton num={num} key={num} setNums={setNums} />
                ))}
              </div>
            </>
          )}
        </main>
        {!(nums.length > 0) || (
          <footer className="my-5">
            <span className="text-muted">Shivam's things: </span>
            <a href="https://shivam.pro" target="_blank" rel="noopener noreferrer">
              shivam.pro
            </a>
          </footer>
        )}
      </div>
    </div>
  );
}

export default App;
